module.exports = __webpack_public_path__ + "images/icons_v2/list-1f21a53c.svg";